<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "ViewForcastIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
